module.exports = __webpack_public_path__ + "static/img/pijiu.fcbd004e.png";